import { useReactiveVar } from "@apollo/client";
import { isEmbedVar } from "../vars";
export const useEmbedMode = () => {
    const isEmbedMode = useReactiveVar(isEmbedVar);
    return {
        isEmbedMode,
    };
};
